import{debounce as u}from"./debounce.js";function f(r,t=0,e={}){typeof e!="object"&&(e={});const{leading:i=!0,trailing:n=!0,signal:a}=e;return u(r,t,{leading:i,trailing:n,signal:a,maxWait:t})}export{f as throttle};
